import { Box, Divider, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CloudDownload } from '@material-ui/icons';
import { IconButton } from '@roc/ui';
import { sanitizeHtml } from '@roc/ui/utils';
import { observer } from 'mobx-react';

const useStyles = makeStyles(() => ({
  description: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  descriptionContainer: {
    display: 'inline-block',
    padding: '10px 18px',
    maxHeight: '150px',
    overflowY: 'auto'
  }
}))

export type ManualTaskInfoProps = {
  document: any,
  store: any,
  description: string,
};

export const ManualTaskInfo = observer(
  (props: ManualTaskInfoProps) => {
    const classes = useStyles();
    const { document, store, description } = props;

    return (
      <Grid container spacing={2}>
        <Grid item xs={10}>
          <Typography
            component="span"
            style={{ display: 'inline-block', padding: '10px 0px' }}
          >
            <Typography component="span" color="textSecondary">
            </Typography>
            <strong>
              {document?.itemName || ''}
            </strong>
          </Typography>
        </Grid>
        <Grid spacing={2} container alignItems="center" justifyContent="space-between">
          <Grid item xs={6}>
            <Typography component="span" className={classes.descriptionContainer}>
              <Typography component="span" color="textSecondary">
                Description:{' '}
              </Typography>
              <div
                className={classes.description}
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(description) }}
              />
            </Typography>
          </Grid>

          {(store.canDownloadFile || store.canDownloadFileFromInfoScreen) && document.originalFileName && (
            <Grid item xs={6}>
              <Box display="flex" justifyContent="flex-end">
                <IconButton
                  type="button"
                  color="primary"
                  testId="download"
                  onClick={() =>
                    store.canDownloadFile
                      ? store.downloadDocument(document)
                      : store.downloadDocumentByPath()
                  }
                >
                  <CloudDownload />
                </IconButton>
              </Box>
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  }
);
